import { render, staticRenderFns } from "./ehc-feedback-form.vue?vue&type=template&id=534c03d9"
import script from "./ehc-feedback-form.vue?vue&type=script&lang=js"
export * from "./ehc-feedback-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports